var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkbrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#8f6963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149-95q-39.05 0-66.53-27.47Q55-149.95 55-189v-450q0-39.46 27.47-67.23Q109.95-734 149-734h148v-100q0-38 27.48-66 27.47-28 66.52-28h178q39.05 0 66.53 28Q663-872 663-834v100h148q39.46 0 67.23 27.77Q906-678.46 906-639v450q0 39.05-27.77 66.53Q850.46-95 811-95H149Zm242-639h178v-100H391v100Zm420 354H571v60H391v-60H149v191h662v-191Zm-360 0h60v-60h-60v60Zm-302-60h242v-60h180v60h240v-199H149v199Zm331 30Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkbrown);
export default __webpack_public_path__ + "static/media/workbrown.cbf260ab3e7ee197665bd06304d97eec.svg";
export { ForwardRef as ReactComponent };